import * as types from './actionTypes';
import * as API_END_POINTS from '../constants/api.js';
import axios from 'axios';
import { appBasePath } from '../constants/staticData';

export function manageuserinfo() {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));

  return dispatch => {
    dispatch(showloader());
    axios
      .get(API_END_POINTS.GET_DRIVERS_LIST, {
        headers: {
          'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(hideloader());
          dispatch({
            type: types.MANAGE_USER_INFO,
            userInfo: response.data
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function manageVehicleinfo() {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  return dispatch => {
    dispatch(showloader());
    axios
      .get(API_END_POINTS.GET_VEHICLE_LIST, {
        headers: {
          'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(hideloader());
          dispatch({
            type: types.MY_VEHICLE_INFO,
            vehicleInfo: response.data
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function showPopUP() {
  return dispatch => {
    //axios.defaults.headers.common['x-access-token'] = localStorage.getItem('businessAccessToken');
    dispatch({
      type: types.MY_VEHICLE_POPUP,
      popupToggle: true
    });
  };
}

export function hidePopUP() {
  return dispatch => {
    //axios.defaults.headers.common['x-access-token'] = localStorage.getItem('businessAccessToken');
    dispatch({
      type: types.MY_VEHICLE_POPUP,
      popupToggle: false
    });
  };
}

export function showloader() {
  return dispatch => {
    //axios.defaults.headers.common['x-access-token'] = localStorage.getItem('businessAccessToken');
    dispatch({
      type: types.LOADER_DISPLAY,
      displayloader: true
    });
  };
}

export function hideloader() {
  return dispatch => {
    //axios.defaults.headers.common['x-access-token'] = localStorage.getItem('businessAccessToken');
    dispatch({
      type: types.LOADER_DISPLAY,
      displayloader: false
    });
  };
}

export function MapsInfo(MapsData) {
  return dispatch => {
    //axios.defaults.headers.common['x-access-token'] = localStorage.getItem('businessAccessToken');
    dispatch({
      type: types.MY_MAPS_INFO,
      mapInfo: MapsData
    });
  };
}

export function getDriverTypes() {
  //let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  return dispatch => {
    axios
      .get(API_END_POINTS.GET_DRIVER_TYPES, {
        headers: {
          //'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: types.DRIVER_TYPES,
            driverTypes: response.data
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}
export function addUser(driverDetails, router) {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  return dispatch => {
    axios
      .post(API_END_POINTS.ADD_USER, driverDetails, {
        headers: {
          'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(hidePopUP());
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: 'Driver added succesfully',
            toastType: 'success'
          });
          dispatch(manageuserinfo());
          if (router) {
            router.push(`${appBasePath}/manage-Users`);
          }
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function editUser(driverDetails, driverId, router) {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  return dispatch => {
    axios
      .put(API_END_POINTS.EDIT_DRIVER_INFO + driverId, driverDetails, {
        headers: {
          'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: 'Driver Info edited succesfully',
            toastType: 'success'
          });
          dispatch(manageuserinfo());
          if (router) {
            router.push(`${appBasePath}/manage-Users`);
          }
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function deleteUser(driverId) {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  return dispatch => {
    axios
      .delete(API_END_POINTS.EDIT_DRIVER_INFO + driverId, {
        headers: {
          'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: 'Driver is deleted succesfully',
            toastType: 'success'
          });

          dispatch(manageuserinfo());
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}
export function getVehicleTypes() {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  return dispatch => {
    axios
      .get(API_END_POINTS.GET_VEHICLE_TYPES, {
        headers: {
          'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: types.VEHICLE_TYPES,
            vehicleTypes: response.data
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}
export function addVehicleInfo(VehicleInfo, router) {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  return dispatch => {
    axios
      .post(API_END_POINTS.ADD_VEHICLE_INFO, VehicleInfo, {
        headers: {
          'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: 'Vehicle added succesfully',
            toastType: 'success'
          });
          router.push(`${appBasePath}/my-Vehicles`);
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function deleteVehicle(driverId, router) {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  return dispatch => {
    axios
      .delete(API_END_POINTS.CRUD_VEHICLE + driverId, {
        headers: {
          'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: 'Vehicle deleted succesfully',
            toastType: 'success'
          });
          dispatch(manageVehicleinfo());
          router.push(`${appBasePath}/my-Vehicles`);
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function getVehicleDetails(vehicleId) {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  return dispatch => {
    axios
      .get(API_END_POINTS.CRUD_VEHICLE + vehicleId, {
        headers: {
          'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: types.VEHICLE_INFO,
            vehicleDetails: response.data
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function editVehicle(vehicleId, vehicleInfo, router) {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  return dispatch => {
    axios
      .put(API_END_POINTS.CRUD_VEHICLE + vehicleId, vehicleInfo, {
        headers: {
          'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: 'Vehicle Info edited succesfully',
            toastType: 'success'
          });
          router.push(`${appBasePath}/my-Vehicles`);
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}
export function clearvehicleInfo() {
  return dispatch => {
    dispatch({
      type: types.VEHICLE_INFO,
      vehicleDetails: {}
    });
  };
}

export function JobsQueueHistory(vehicleId, typeInfo) {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));

  return dispatch => {
    dispatch(showloader());
    axios
      .get(API_END_POINTS.VEHICLE_HISTORY_QUEUE + vehicleId + '/jobslist?type=' + typeInfo + '&limit=100&offset=10', {
        headers: {
          'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(hideloader());
          if (typeInfo == 'history') {
            dispatch({
              type: types.LIST_HISTORY,
              historyInfo: response.data
            });
          } else {
            dispatch({
              type: types.LIST_QUEUE,
              queueInfo: response.data
            });
          }
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/manageUserActions.js